window.addEventListener("load", () => {
  const megaMenuTriggers = document.querySelectorAll(
    ".menu-item-has-children.level-0"
  );
  const mobileBack = document.querySelector('#mobile-menu-return button');
  const parentMenuItems = document.querySelectorAll('#menu-main-menu .level-0');
  const mainMenuWrapper = document.querySelector('#menu-main-menu-wrapper');
  const mobileMenuTrigger = document.querySelector('#mobile-menu-trigger');
  const hamburger = mobileMenuTrigger.querySelector('.hamburger');
  const body = document.querySelector("body");
  const menu = document.querySelector("#header-wrapper nav");

  // Functions
  function manageStickyMenu(e) {
    if (window.scrollY > menu.offsetHeight) {
      menu.classList.add("scrolled");
      if (e.type === "scroll" || e.type === "touchmove") {
        this.oldScroll > this.scrollY
          ? menu.classList.add("visible")
          : menu.classList.remove("visible");
        this.oldScroll = this.scrollY;
      }
    } else if (window.scrollY < 10) {
      menu.classList.remove("scrolled", "visible");
    }
  }

  // Events
  window.addEventListener("scroll", manageStickyMenu);
  window.addEventListener("touchmove", manageStickyMenu);

  function toggleMenu() {
    hamburger.classList.toggle('active');
    mainMenuWrapper.classList.toggle('parent-items-visible');
    mainMenuWrapper.classList.contains('child-items-visible') && resetMenu();
    mainMenuWrapper.classList.remove('child-items-visible');
    body.classList.toggle('mobile-menu-open');
  }

  mobileMenuTrigger.addEventListener('click', toggleMenu);

  mobileBack.addEventListener('click', resetMenu);

  function resetMenu(){
    console.log('reset calles');
    
      mainMenuWrapper.classList.remove('child-items-visible');
      const activeParent = mainMenuWrapper.querySelector('.menu-open');
      const activeSubmenu = activeParent.querySelector('.mega-menu-wrapper');
      activeSubmenu.addEventListener('transitionend', handleTransitionEnd);
      activeSubmenu.style.opacity = '0';
      activeParent.style.opacity = '0';
      activeParent.classList.remove('menu-open');
  
      function handleTransitionEnd(e) {
        
        if (e.propertyName === 'opacity') {
          activeSubmenu.style.transform = 'translateY(-200%)';
          
          // Only reset classes for non-active parents
          parentMenuItems.forEach(parent => {
              parent.classList.remove('hidden');
              parent.style.opacity = "1"
          });
  
          activeSubmenu.removeEventListener('transitionend', handleTransitionEnd);
        }
      }
  }

  megaMenuTriggers.forEach((trigger) => {
    const megaMenu = trigger.querySelector(".mega-menu-wrapper");
    megaMenu.style.transform = 'translateY(-200%)';

    const handleTransition = (e, mobile = false, el = null) => {
      if (e.propertyName === 'opacity') {
        if (!mobile) {
          if (megaMenu.style.opacity === '0') {
            megaMenu.style.transform = 'translateY(-200%)';
            megaMenu.removeEventListener('transitionend', handleTransition);
          }
        } 
          el.removeEventListener('transitionend', handleTransition);
      }
    };

    //const handleTransitionWrapper = (e) => handleTransition(e, true, trigger);

    trigger.addEventListener('click', function (e) {
      if (mainMenuWrapper.classList.contains('parent-items-visible')) {
        if (!mainMenuWrapper.classList.contains('child-items-visible')) {
          e.preventDefault();
          //this.addEventListener('transitionend', handleTransitionWrapper);
          mainMenuWrapper.classList.add('child-items-visible');
          trigger.classList.add("menu-open");
          megaMenu.style.transform = 'translateY(0%)';
          megaMenu.style.opacity = '1';
          megaMenu.setAttribute("aria-expanded", "true");
        }
        parentMenuItems.forEach(parentItem => {
          if (!parentItem.classList.contains('menu-open') && !parentItem.classList.contains('hidden')) {
            parentItem.style.opacity = "0";
            parentItem.classList.add('hidden');
          }
        });
      }
    });

    trigger.addEventListener("mouseenter", (e) => {
      if (!mainMenuWrapper.classList.contains('parent-items-visible')) {
        megaMenu.addEventListener('transitionend', handleTransition);
        trigger.classList.add("menu-open");
        megaMenu.style.transform = 'translateY(0%)';
        megaMenu.style.opacity = '1';
        megaMenu.setAttribute("aria-expanded", "true");
      }
    });

    trigger.addEventListener("mouseleave", () => {
      if (!mainMenuWrapper.classList.contains('parent-items-visible')) {
        body.classList.remove('stop-scroll');
        trigger.classList.remove("menu-open");
        megaMenu.style.opacity = '0';
        megaMenu.setAttribute("aria-expanded", "false");
        megaMenu.addEventListener('transitionend', handleTransition);
      }
    });
  });
});
